import { render, staticRenderFns } from "./Journeycategories.vue?vue&type=template&id=af1ce878&scoped=true&"
import script from "./Journeycategories.vue?vue&type=script&lang=js&"
export * from "./Journeycategories.vue?vue&type=script&lang=js&"
import style0 from "./Journeycategories.vue?vue&type=style&index=0&id=af1ce878&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af1ce878",
  null
  
)

export default component.exports